import React from 'react'
import PageHeader from '../components/shared/pageHeader/PageHeader'

import LanguageTable from '../components/leads/SelectElements'
import Footer from '../components/shared/Footer'

const LanguagesEditTable = () => {
    return (
        <>
            <PageHeader>
               
            </PageHeader>
            <div className='main-content'>
                <div className='row'>
                    <LanguageTable />
                </div>
            </div>
            
        </>
    )
}

export default LanguagesEditTable